import { render, staticRenderFns } from "./MedicationLabelsRep.vue?vue&type=template&id=64a08f9d&"
import script from "./MedicationLabelsRep.vue?vue&type=script&lang=js&"
export * from "./MedicationLabelsRep.vue?vue&type=script&lang=js&"
import style0 from "./MedicationLabelsRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports